import './events.less'

import {action, m, StatelessView, style} from '@codeurs/front'
import {compareAsc, compareDesc, isAfter, isValid, startOfToday} from 'date-fns'
import parse from 'date-fns/parse'
import {Event} from 'types'
import Layout from 'views/layout'
import {
	Card,
	CardContent,
	CardFooter,
	CardImage,
	CardLink,
	CardTitle
} from 'views/layout/card'
import {CollectionTitle} from 'views/layout/collectiontitle'
import ContentContainer from 'views/layout/contentcontainer'
import Wysiwyg from 'views/layout/wysiwyg'
import EventImage from 'views/partials/events/eventimage'

const EventsItem: StatelessView<Event> = ({
	url,
	title,
	description,
	intro_image,
	start_date
}) => {
	const date = parse(start_date)
	return m(style(Card, '.eventsitem'),
		m(CardImage,
			intro_image,
			isValid(date) &&
				m('.eventsitem-date', m(EventImage, {mod: 'small', start_date: date}))
		),
		m(CardContent, [
			m('a', action(url), m(CardTitle, title)),
			m('a', action(url), m(Wysiwyg, {html: description})),
			m(CardFooter, m(CardLink, action(url), 'Read more'))
		])
	)
}

export class Events extends Layout<{
	events: Array<Event>
}> {
	view() {
		const {events} = this.attrs.data
		const now = startOfToday()
		const {upcoming, past} = events
			.map(event => ({...event, date: parse(event.start_date)}))
			.reduce(
				(acc, event) => {
					;(isAfter(event.date, now) ? acc.upcoming : acc.past).push(event)
					return acc
				},
				{upcoming: [], past: []}
			)
		return m('.events',
			m(ContentContainer, [
				upcoming.length + past.length === 0 &&
					m('.events-empty', 'There are currently no events'),
				upcoming.length > 0 && [
					m(CollectionTitle, 'Upcoming events'),
					upcoming
						.sort((a, b) => compareAsc(a.date, b.date))
						.map(event => m(EventsItem, event))
				],
				past.length > 0 && [
					m(CollectionTitle, 'Past events'),
					past
						.sort((a, b) => compareDesc(a.date, b.date))
						.map(event => m(EventsItem, event))
				]
			])
		)
	}
}
